import React, { Fragment, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { CurrencyExchangeRateInitialsForAdd, CurrencyExchangeRateInitialsForUpdate } from "./interfaces/CurrencyExchangeRateClass";
import { addAccountCurrencyExchangeRateAsync, updateAccountCurrencyExchangeRateAsync, resetSelectedRecordObjectInState } from "./CurrencyExchangeRateSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { dateFormatByAccountCulture, getValueFromResource, FormatNumberCultureAware, determineCommaSeprater, parseLocaleNumber, parseLocalizedNumber } from '../../../common/timeLiveFunction'; 


export const CurrencyExchangeRateForm = (props: any) => {

    const { AccountCurrencyId,t, oncloseModal } = props;
    const { selectedRecord, isLoading } = useAppSelector((state) => state.currencyExchangeRate);
    const [currentFieldsData, SetcurrentFieldsData] = useState<any>(CurrencyExchangeRateInitialsForAdd);
    const { CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, customFieldInsertionFormat, calendarStartDay } = useAppSelector((state) => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {}    
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(CurrencyExchangeRateInitialsForUpdate).map((item) => {
                if (item === 'AccountCurrencyId') {
                    return stateItem[item] = AccountCurrencyId;
                }
                else {
                    return stateItem[item] = tempObj[item];
                }
            })
           
            // stateItem.ExchangeRateEffectiveStartDate = new Date(stateItem.ExchangeRateEffectiveStartDate);
            // stateItem.ExchangeRateEffectiveEndDate = new Date(stateItem.ExchangeRateEffectiveEndDate);
            //stateItem.ExchangeRateEffectiveStartDate = dateFormatByAccountCulture(stateItem.ExchangeRateEffectiveStartDate, cultureInfoName.toString());
            //stateItem.ExchangeRateEffectiveEndDate = dateFormatByAccountCulture(stateItem.ExchangeRateEffectiveEndDate, cultureInfoName.toString());
            stateItem.ExchangeRateEffectiveStartDate = dateFormatByAccountCulture(moment.parseZone(stateItem.ExchangeRateEffectiveStartDate).format(dateInsertionFormat), cultureInfoName.toString());
            stateItem.ExchangeRateEffectiveEndDate = dateFormatByAccountCulture(moment.parseZone(stateItem.ExchangeRateEffectiveEndDate).format(dateInsertionFormat), cultureInfoName.toString());
            stateItem.ExchangeRate = FormatNumberCultureAware(cultureInfoName.toString(),stateItem.ExchangeRate);
            SetcurrentFieldsData(stateItem);
             console.log('stateItem',stateItem)
        }
        else {
            SetcurrentFieldsData({ ...CurrencyExchangeRateInitialsForAdd, "AccountCurrencyId": AccountCurrencyId });
        }
    }, [selectedRecord])

    const handleSubmit = (values: any) => {

        if (values.IsUpdateExpenseEntry === undefined) {
            values.IsUpdateExpenseEntry = false;
        }

        // const formattedValues = {
        //                 ...values,
        //                 ExchangeRate: parseLocalizedNumber(values.ExchangeRate)}
         const formattedValues = {
        ...values,
        ExchangeRate: parseLocalizedNumber(values.ExchangeRate),
        ExchangeRateEffectiveStartDate: moment(values.ExchangeRateEffectiveStartDate).format("YYYY-MM-DD"),
        ExchangeRateEffectiveEndDate: moment(values.ExchangeRateEffectiveEndDate).format("YYYY-MM-DD")
    }
        console.log('handleSubmit', formattedValues)
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountCurrencyExchangeRateAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Exchange Rate Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
         
                }).catch((rejectedValueOrSerializedError) => {
         
                })
        }
        else {
            dispatch(addAccountCurrencyExchangeRateAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Exchange Rate Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
         
                }).catch((rejectedValueOrSerializedError) => {
         
                })
        }
        oncloseModal();
    }

    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}

                validationSchema={yup.object().shape({
                    // ExchangeRate: yup
                    //     .number()
                    //     // .min(1,
                    //     //     getValueFromResource('Zero not allowed in exchange rate field',dispatch, t))
                    //     .typeError(getValueFromResource('Exchange rate must be a number', dispatch, t))
                    //     .moreThan(
                    //         0,
                    //         getValueFromResource('Zero not allowed in exchange rate field', dispatch, t)
                    //     )
                    //     .required
                    //     // (t('Exchange rate is required')),
                    //     (getValueFromResource('Exchange rate is required',dispatch, t)),
                    ExchangeRate: yup.string()
                                    .test(
                                        'culture-format-check',
                                        () => {
                                            const isComma = determineCommaSeprater(cultureInfoName.toString());
                                            return isComma
                                                ? "Only numbers and comma (,) are allowed."
                                                : "Only numbers and dot (.) allowed";
                                        },
                    
                                        (value) => {
                                            if (!value) return true;
                                            const isComma = determineCommaSeprater(cultureInfoName.toString());
                                            if (isComma) {
                                                return /^\d+(,\d+)?$/.test(value);
                                            } else {
                                                return /^\d+(\.\d+)?$/.test(value);
                                            }
                                        }
                                    )
                                    .test(
                                        'greater-than-zero',
                                        getValueFromResource('Quantity must be greater than or equal to 0', dispatch, t),
                                        (value) => {
                                            if (!value) return true;
                    
                                            const isComma = determineCommaSeprater(cultureInfoName.toString());
                                            let normalizedValue = value;
                                            if (isComma) {
                                                normalizedValue = value.replace(',', '.');
                                            }
                    
                                            const numberValue = parseFloat(normalizedValue);
                                            return !isNaN(numberValue) && numberValue >= 0;
                                        }
                                    ),
                    ExchangeRateEffectiveStartDate: yup
                        .date()
                        .required
                        // (t('Start Date is required')),
                        (getValueFromResource('Start Date is required',dispatch, t)),
                    ExchangeRateEffectiveEndDate: yup
                        .date()
                        .required
                        // (t('End Date is required'))
                        (getValueFromResource('End Date is required',dispatch, t))
                        .min(yup.ref('ExchangeRateEffectiveStartDate'), 
                        // t('End date must be after start date')),
                        getValueFromResource('End date must be after start date',dispatch, t)),

                })}>
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                       
                        <div className="modal drawer-overlay" style={{ display: 'block' }} >
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                                        // t('Update')
                                        getValueFromResource('Update ',dispatch, t)
                                         :
                                        //  t('Add')} 
                                        getValueFromResource('Add ',dispatch, t)}
                                         {/* {t('Exchange Rate')}  */}
                                         {getValueFromResource('Exchange Rate',dispatch, t)}
                                         </h5>
                                        <div
                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                            onClick={oncloseModal}
                                        >
                                            <KTSVG
                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                className="svg-icon svg-icon-1x"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <label className="fs-7 fs-7 fw-normal mb-2">
                                                {/* {t('Exchange Rate')} */}
                                                {getValueFromResource('Exchange Rate',dispatch, t)}

                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='ExchangeRate'
                                                name="ExchangeRate"
                                                value={values.ExchangeRate}
                                                onChange={handleChange('ExchangeRate')}
                                                onBlur={() => setFieldTouched('ExchangeRate')}
                                            />
                                            <div>
                                                {touched.ExchangeRate && errors.ExchangeRate &&
                                                    <p className='errorMsg'>{errors.ExchangeRate as string}</p>
                                                }
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="fs-7 fs-7 fw-normal mb-2">
                                                {/* {t('Start Date')} */}
                                                {getValueFromResource('Start Date',dispatch, t)}

                                                </label>
                                            {/* <div className="input-group"> */}
                                                <div className="position-relative">
                                                    <DatePicker
                                                        selected={values.ExchangeRateEffectiveStartDate}
                                                        id="ExchangeRateEffectiveStartDate"
                                                        name="ExchangeRateEffectiveStartDate"
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control fs-7 fw-normal dataPicker w-220px ps-4 form-control-dark btn-icon-dark btn-text-dark"
                                                        onChange={(date) => setFieldValue('ExchangeRateEffectiveStartDate', date)}
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                        onBlur={() => setFieldTouched('ExchangeRateEffectiveStartDate')}
                                                    />
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray position-absolute end-0 top-50 translate-middle-y pe-3"></i>
                                                </div>
                                            
                                            {/* </div> */}
                                            <div>
                                                {touched.ExchangeRateEffectiveStartDate && errors.ExchangeRateEffectiveStartDate &&
                                                    <p className='errorMsg'>{errors.ExchangeRateEffectiveStartDate as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="fs-7 fs-7 fw-normal mb-2">
                                                {/* {t('End Date')} */}
                                                {getValueFromResource('End Date',dispatch, t)}

                                                </label>
                                                <div className="position-relative">
                                                    <DatePicker
                                                        selected={values.ExchangeRateEffectiveEndDate}
                                                        id="ExchangeRateEffectiveEndDate"
                                                        name="ExchangeRateEffectiveEndDate"
                                                        className="form-control fs-7 fw-normal dataPicker w-220px ps-4 form-control-dark btn-icon-dark btn-text-dark"
                                                        onChange={(date) => setFieldValue('ExchangeRateEffectiveEndDate', date)}
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                        onBlur={() => setFieldTouched('ExchangeRateEffectiveEndDate')}
                                                    />
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray position-absolute end-0 top-50 translate-middle-y pe-3"></i>
                                                </div>
                                            <div>
                                                {touched.ExchangeRateEffectiveEndDate && errors.ExchangeRateEffectiveEndDate &&
                                                    <p className='errorMsg'>{errors.ExchangeRateEffectiveEndDate as string}</p>
                                                }
                                            </div>
                                        </div>
                                        </div>

                                        {(Object.keys(selectedRecord).length > 0) ? (
                                            <div className="col-md-6">
                                                <label className="fs-7 fs-7 fw-normal mb-2">
                                                    {/* {t('Update all record within this range')} */}
                                                    {getValueFromResource('Update all record within this range',dispatch, t)}

                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px"
                                                        type="checkbox"
                                                        id="IsUpdateExpenseEntry"
                                                        name="IsUpdateExpenseEntry"
                                                        checked={values.IsUpdateExpenseEntry}
                                                        onChange={handleChange('IsUpdateExpenseEntry')}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                            onClick={oncloseModal}
                                        >
                                            {/* {t('Cancel')} */}
                                            {getValueFromResource('Cancel',dispatch, t)}

                                        </button>
                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                        {/* {t('Save')}   */}
                                        {getValueFromResource('Save',dispatch, t)}

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </Fragment>
                )}
            </Formik>
        </>
    )

}

